const resultDialog = {
  importResult: "นำเข้าผลลัพธ์",
  failReason: "สาเหตุของความล้มเหลว",
  noFailReason: "ไม่มีข้อมูลความล้มเหลวในการนำเข้า",
  importSuccess: "นำเข้าความสำเร็จ",
  unit: "แถบ",
  importFail: "การนำเข้าล้มเหลว"
} 
export default resultDialog